var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [
        _vm._v(_vm._s(_vm.$t("message.automationFeature"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.automationEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "automationEntegration", $$v)
                  },
                  expression: "featureForm.automationEntegration",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.automationIntegration")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.automationEventBase,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "automationEventBase", $$v)
                  },
                  expression: "featureForm.automationEventBase",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.eventBasedAutomation")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.automationWebhookBase,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "automationWebhookBase", $$v)
                  },
                  expression: "featureForm.automationWebhookBase",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.webhookBasedAutomation")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.automationButtonBase,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "automationButtonBase", $$v)
                  },
                  expression: "featureForm.automationButtonBase",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.buttonBasedAutomation")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.automationTimerBase,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "automationTimerBase", $$v)
                  },
                  expression: "featureForm.automationTimerBase",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.timerBasedAutomation")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.automationCreationLimit"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.automationLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "automationLimit", $$v)
                },
                expression: "featureForm.automationLimit",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.freeTaskLimitPerMonth"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.automationTaskFreeLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "automationTaskFreeLimit", $$v)
                },
                expression: "featureForm.automationTaskFreeLimit",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.blockCount"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.automationBlock,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "automationBlock", $$v)
                },
                expression: "featureForm.automationBlock",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }